/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as TwilioConsentPageLoader } from './TwilioConsentPage/TwilioConsentPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PaymentsHistoryPageLoader } from './PaymentsHistoryPage/PaymentsHistoryPage.duck';
import {
  loadData as PreferredTalentPageLoader,
  loadSuppliersData as PreferredSuppliersPageLoader,
  loadMyNetworkData as MyNetworkPageLoader,
  loadCustomersData as NetworkCustomersPageLoader,
} from './PreferredTalentPage/PreferredTalentPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as PrivacyPolicyCustomPageLoader } from './PrivacyPolicyCustomPage/PrivacyPolicyCustomPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as ProfileSettingsPageLoader } from './ProfileSettingsPage/ProfileSettingsPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import { loadData as TermsAndConditionsCustomPageLoader } from './TermsAndConditionsCustomPage/TermsAndConditionsCustomPage.duck';
import { loadData as UserManagementPageLoader } from './UserManagementPage/UserManagementPage.duck';
import { loadData as DashboardPageLoader } from './DashboardPage/DashboardPage.duck';
import { loadData as CalendarPageLoader } from './CalendarPage/CalendarPage.duck';
import { loadData as WalletPageLoader } from './WalletPage/WalletPage.duck';
import { loadData as SkillFitInterviewGatePageLoader } from './SkillFitInterviewGatePage/SkillFitInterviewGatePage.duck';
import { loadData as SkillFitReportPageLoader } from './SkillFitReportPage/SkillFitReportPage.duck';
import { loadData as SkillFitTranscriptPageLoader } from './SkillFitTranscriptPage/SkillFitTranscriptPage.duck';
import { loadData as SkillFitCandidateFeedbackPageLoader } from './SkillFitCandidateFeedbackPage/SkillFitCandidateFeedbackPage.duck';
import { loadData as JobPostsPageLoader } from './JobPostsPage/JobPostsPage.duck';
import { loadData as RFPPostsPageLoader } from './RFPPostsPage/RFPPostsPage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as PersonaVerificationPageLoader } from './PersonaVerification/PersonaVerification.duck';
import { loadData as SingleBlogPageLoader } from './SingleBlogPage/SingleBlogPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    TwilioConsentPage: {
      loadData: TwilioConsentPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PreferredTalentPage: {
      loadData: PreferredTalentPageLoader,
    },
    PreferredSuppliersPage: {
      loadData: PreferredSuppliersPageLoader,
    },
    MyNetworkPage: {
      loadData: MyNetworkPageLoader,
    },
    NetworkCustomersPage: {
      loadData: NetworkCustomersPageLoader,
    },
    PaymentsHistoryPage: {
      loadData: PaymentsHistoryPageLoader,
    },
    TermsAndConditionsCustomPage: {
      loadData: TermsAndConditionsCustomPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    PrivacyPolicyCustomPage: {
      loadData: PrivacyPolicyCustomPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    ProfileSettingsPage: {
      loadData: ProfileSettingsPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    UserManagementPage: {
      loadData: UserManagementPageLoader,
    },
    DashboardPage: {
      loadData: DashboardPageLoader,
    },
    CalendarPage: {
      loadData: CalendarPageLoader,
    },
    WalletPage: {
      loadData: WalletPageLoader,
    },
    SkillFitInterviewGatePage: {
      loadData: SkillFitInterviewGatePageLoader,
    },
    SkillFitReportPage: {
      loadData: SkillFitReportPageLoader,
    },
    SkillFitTranscriptPage: {
      loadData: SkillFitTranscriptPageLoader,
    },
    SkillFitCandidateFeedbackPage: {
      loadData: SkillFitCandidateFeedbackPageLoader,
    },
    JobPostsPage: {
      loadData: JobPostsPageLoader,
    },
    RFPPostsPage: {
      loadData: RFPPostsPageLoader,
    },
    PersonaVerificationPage: {
      loadData: PersonaVerificationPageLoader,
    },
    SingleBlogPage: {
      loadData: SingleBlogPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
